//
//
//
//
//
//
//
//
//
//

import axios from 'axios';

export default {
    props : {
        lang : {
            type : String,
            required : true,
            default: 'fi'
        }
    },
    mounted () {
        axios.get('/wp-json/vtv/v1/jobs/?lang=' + this.lang)
        .then((response) => {

            // Get response & parse to json
            if(response.data.json) {
                this.positions = JSON.parse(response.data.json);
            } else if(response.data) {
                this.positions = JSON.parse(response.data.json);
            } else {
                // Return no vacancies if no response
                this.text = this.no_vacancies_text;
            }

            // If response items empty, also return no vacancies
            if(!this.positions.item) {
                this.text = this.no_vacancies_text;
            }

            // If only one position, put in in the array.
            // If item is an array (as in there are many positions) return that array as is
            if(!Array.isArray(this.positions.item)){
                this.positionsArray.push(this.positions.item)
            } else {
                this.positionsArray = this.positions.item
            }

            this.loading = false;
        }).catch((error) => {
            this.text = this.no_vacancies_text;
            this.loading = false;
        })
    },
    data : function () {
        return {
            positions: {},
            positionsArray: [],
            text: '',
            icons: rest_options.options.icons,
            no_vacancies_text: rest_options.options.translations.jobs.no_vacancies_text,
            error: rest_options.options.translations.jobs.error,
            loading: true
        };
    }
}



// WEBPACK FOOTER //
// ./js/vue/jobs-component/jobs-component.vue